const cents = value => Math.round((Number(value) || 0) * 100);
const dollars = value => Math.round(value) / 100;

export const bulkSavings = (items = []) => {
  const unitPrices = [];
  for (const item of items) {
    if (item?.product_form !== "lyophilized_vial") continue;
    const qty = Math.max(0, Math.floor(Number(item.qty) || 0));
    for (let i = 0; i < qty; i += 1) unitPrices.push(cents(item.price));
  }
  unitPrices.sort((a, b) => a - b);
  const discountedUnits = Math.floor(unitPrices.length / 10) * 10;
  const discountedCents = unitPrices.slice(0, discountedUnits).reduce((sum, price) => sum + price, 0);
  return {
    savings: dollars(Math.round(discountedCents * 0.2)),
    discountedUnits,
    eligibleUnits: unitPrices.length,
  };
};

export const priceCart = ({ items = [], coupon, freeThreshold = Infinity, flatShippingRate = 0, freeShippingEnabled = true }) => {
  const subtotalCents = items.reduce((sum, item) => sum + cents(item?.price) * Math.max(0, Math.floor(Number(item?.qty) || 0)), 0);
  const bulk = bulkSavings(items);
  const bulkCents = cents(bulk.savings);
  const postBulkCents = Math.max(0, subtotalCents - bulkCents);
  const minimumCents = cents(coupon?.min_subtotal);
  const eligibleCoupon = coupon && (!minimumCents || postBulkCents >= minimumCents) ? coupon : null;
  let couponCents = 0;
  if (eligibleCoupon?.type === "percent") couponCents = Math.min(postBulkCents, Math.round(postBulkCents * Number(eligibleCoupon.value || 0) / 100));
  if (eligibleCoupon?.type === "fixed") couponCents = Math.min(postBulkCents, cents(eligibleCoupon.value));

  const thresholdCents = Number.isFinite(Number(freeThreshold)) ? cents(freeThreshold) : Infinity;
  const freeByThreshold = freeShippingEnabled !== false && postBulkCents >= thresholdCents;
  // A free_shipping coupon forces $0 even when threshold-based free shipping is
  // disabled -- place_order applies v_force_free_ship before the enabled check.
  const freeByCoupon = eligibleCoupon?.type === "free_shipping";
  const shippingCents = freeByThreshold || freeByCoupon ? 0 : cents(flatShippingRate);

  return {
    subtotal: dollars(subtotalCents),
    bulkSavings: bulk.savings,
    discountedUnits: bulk.discountedUnits,
    eligibleUnits: bulk.eligibleUnits,
    postBulk: dollars(postBulkCents),
    couponDiscount: dollars(couponCents),
    shipping: dollars(shippingCents),
    totalBeforeCredit: dollars(postBulkCents - couponCents + shippingCents),
  };
};
